import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Incoterm, CreateIncotermDto, UpdateIncotermDto } from '../../models/forwarding/incoterm.model';

@Injectable({ providedIn: 'root' })
export class IncotermService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/forwarding/incoterms`;

  getAll(): Observable<Incoterm[]> {
    return this.http.get<Incoterm[]>(this.apiUrl);
  }

  getById(id: number): Observable<Incoterm> {
    return this.http.get<Incoterm>(`${this.apiUrl}/${id}`);
  }

  create(dto: CreateIncotermDto): Observable<Incoterm> {
    return this.http.post<Incoterm>(this.apiUrl, dto);
  }

  update(id: number, dto: UpdateIncotermDto): Observable<Incoterm> {
    return this.http.put<Incoterm>(`${this.apiUrl}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  // ---- Legacy API shims — used by forwarding-admin and new-quotation components ----

  /** @deprecated Use getAll() */
  getIncoterms(): Observable<Incoterm[]> {
    return this.getAll();
  }

  /** @deprecated No-op shim — BehaviorSubject pattern removed */
  refresh(): void {
    // no-op: new service is stateless; callers should call getAll() directly
  }
}
